function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './HeaderArticle1.css';
import React from 'react';
import { get, getDomain, pathJoin } from '../../utils';
import { Placeholder, Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import LazyPicture from '../atoms/LazyPicture';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';
import getListing from '../../utils/getListing';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { useSeoArticleScript } from '../../utils/seo';

// import RouterLink from '../atoms/RouterLink';

export const formatDate = date => {
  if (date) {
    const dateObj = new Date(date);
    return dateObj.toISOString();
  }
  return date;
};
const HeaderArticle1 = _ref => {
  let {
    fields,
    headerTypeInsights,
    rendering,
    children,
    route,
    params
  } = _ref;
  const addToFavAnalytics = get(fields || {}, 'addToFavAnalytics');
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const isSharedCh = get(params, 'RenderingStyle') === 'Shared Channels' || false;
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const itemID = get(route, 'itemId', '');
  const bannerTitleName = get(route, 'name', '');
  // const itemID = "a3648f04-6051-4f08-a485-77b49c78d5cf";
  const convertedId = itemID.split('-').join('');
  const [searchResults, setSearchResults] = React.useState('');
  const currentLang = get(sitecoreContext, 'language');
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const Dictionaries = get(fields, 'Dictionaries');
  const templateName = get(route, 'templateName', '');
  ;
  const seoTitle = get(fields, 'Title');
  const seoDesc = get(fields, 'Intro Text');
  const isNewsTitle = get(fields, 'Is News Article');
  const seoType = isNewsTitle && isNewsTitle.value ? 'NewsArticle' : 'Article';
  const seoImages = get(fields, 'Fallback image');
  const datePublished = get(fields, 'Writing date');
  const dateModified = get(sitecoreContext, 'lastUpdateDate');
  const MinRead = Dictionaries && Dictionaries.find(item => {
    if (item && item.Key === 'MinRead') {
      return item;
    }
  });
  const script = `
			{
				"@context": "https://schema.org",
				"@type": "${seoType}",
				"headline": "${seoTitle ? seoTitle.value : ''}",
				"image": ["${seoImages && seoImages.value && seoImages.value.src ? pathJoin([getDomain(), seoImages.value.src]) : ''}"],
				"datePublished": "${datePublished && datePublished.value ? formatDate(datePublished.value) : ''}",
				"dateModified": "${dateModified ? formatDate(dateModified) : ''}",
			 "author":
		[
			{
				"@type":"Organization",
				"name": "Visit Dubai",
				"url": "https://www.visitdubai.com/"
		}
	],
		"publisher": {
				"@type": "Organization",
				"name": "Visit Dubai",
				"logo": {
				"@type": "ImageObject",
				"url": "https://www.visitdubai.com/-/media/Common/logos/logo-dubai-grey-75x29.svg?h=29&iar=0&w=75"
					}
		},
	 "description": "${seoDesc ? seoDesc.value : ''}"
			}`;
  useSeoArticleScript(script, 'article-seo-script', templateName);
  React.useEffect(() => {
    if (!headerTypeInsights) {
      let itemFilter = {
        hitsPerPage: 1,
        facetFilters: [['type:Article'], [`objectID:${convertedId}`]]
      };
      getListing(get(params, "SearchIndex"), itemFilter, algoliaSettings).then(hits => {
        setSearchResults(hits && hits.hits[0].readTime);
      });
    }
  }, []);
  if (!fields) {
    console.warn('HeaderArticle component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [HeaderArticle component is empty: please provide data source]");
    }
    return null;
  }
  const setDateFormat = date => {
    return new Date(date).toLocaleDateString(currentLang === 'en' ? 'en-GB' : currentLang, {
      weekday: 'short',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };
  const introTextObject = get(fields, 'Intro Text') || get(fields, 'pageIntro'); //pageIntro
  const introText = get(introTextObject, 'value');
  const title = get(fields, 'Title') || get(fields, 'pageTitle'); //pageTitle
  const authorObject = get(fields, 'Author', [])[0];
  const hasAuthorName = Boolean(get(authorObject, 'fields.Curator name.value')) || Boolean(get(fields, 'Author Name.value'));
  const currentAuthorName = get(authorObject, 'fields.Curator name') || get(fields, 'Author Name');
  const firstCurator = get(fields, 'fields.Curator picks') || [];
  const authorImage = get(authorObject, 'fields.Fallback image.value.src');
  const insightAuthorImage = get(fields, 'Author Image.value.src');
  const insightHeaderAuthorAlt = get(fields, 'Author Image.value.alt');
  const authorName = String(get(authorObject, 'fields.Curator name.value'));
  const hasAuthorCategory = Boolean(get(authorObject, 'fields.Curator role.value')) || Boolean(get(fields, 'Author Title.value'));
  const authorCategory = get(authorObject, 'fields.Curator role') || get(fields, 'Author Title');
  const Location = get(fields, 'Location.value') || get(fields, 'Location.fields.country.value');
  const WritingDate = get(fields, 'Writing date.value') || get(fields, 'Publication date.value') || get(fields, 'dateOfIssue.value');
  const Category = get(fields, 'Category.fields.Title.value') || get(fields, 'category.fields.fullName.value');
  const bodyCharacters = get(fields, 'Body.value.length');
  const Media = get(fields, 'Media'); // eslint-disable-line

  const renderMediaPlaceholder = () => {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "dot-media-header-article",
      rendering: rendering,
      mediaDesc: introText
    });
  };
  const renderInsightHeaderPlaceholder = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Placeholder, {
      name: "media-header-general",
      rendering: rendering,
      mediaDesc: introText
    }));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter'],
    isSharedCh: isSharedCh
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header--article"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alignment-with-richtext-wrapper"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-medium ha__localization"
  }, Category), /*#__PURE__*/React.createElement("div", {
    className: "head-content"
  }, /*#__PURE__*/React.createElement(Text, {
    className: "h1 h__title",
    tag: "h1",
    field: title
  }), /*#__PURE__*/React.createElement("div", {
    className: "ha__user--desk"
  }, !authorImage && /*#__PURE__*/React.createElement(React.Fragment, null), authorImage && /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width:769px)",
    srcSet: authorImage + '&cw=40&ch=40'
  }), /*#__PURE__*/React.createElement("img", {
    src: authorImage + '&cw=40&ch=40',
    alt: authorName
  })), insightAuthorImage && /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width:769px)",
    srcSet: insightAuthorImage + '&cw=40&ch=40'
  }), /*#__PURE__*/React.createElement("img", {
    src: insightAuthorImage + '&cw=40&ch=40',
    alt: insightHeaderAuthorAlt
  })), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, hasAuthorName && /*#__PURE__*/React.createElement(Text, {
    className: "body-medium",
    tag: "p",
    field: currentAuthorName
  }), hasAuthorCategory && /*#__PURE__*/React.createElement(Text, {
    className: "body-small user-category",
    tag: "p",
    field: authorCategory
  })))), (WritingDate || Location) && /*#__PURE__*/React.createElement("div", {
    className: "h__desc"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-medium uppercase"
  }, WritingDate && /*#__PURE__*/React.createElement(React.Fragment, null, setDateFormat(WritingDate)), Location && /*#__PURE__*/React.createElement(React.Fragment, null, ", ", Location)), searchResults && searchResults !== "0" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "body-medium h__seperator-dot"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "6",
    height: "6",
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "6",
    height: "6",
    rx: "3",
    fill: "#DDDEDE"
  }))), /*#__PURE__*/React.createElement("p", {
    className: "body-medium uppercase"
  }, searchResults, " ", MinRead && MinRead.Phrase))), /*#__PURE__*/React.createElement("div", {
    className: "ha__desc--desk"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-5"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "body-large",
    field: introTextObject
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-7 btn-like--desk"
  }, !headerTypeInsights && /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: itemID,
    classes: ' header-events__fav-btn',
    analyticsClick: action => {
      const paramsCopy = _objectSpread({}, params);
      paramsCopy.eventLab = '';
      tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, paramsCopy), `${action} : ${bannerTitleName}`);
    }
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "ha__img"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-bb__wrapper header-bb__wrapper--poster-show"
  }, !headerTypeInsights ? /*#__PURE__*/React.createElement(React.Fragment, null, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder()) : /*#__PURE__*/React.createElement(React.Fragment, null, process.env.STORYBOOK_MODE ? children : renderInsightHeaderPlaceholder()), /*#__PURE__*/React.createElement("div", {
    className: `btn-like ${isSharedCh ? 'fav-btn-box--shared' : ''}`
  }, !headerTypeInsights && /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: itemID,
    classes: ' header-events__fav-btn',
    analyticsClick: action => tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), `${action} : ${bannerTitleName}`)
  })))), /*#__PURE__*/React.createElement("div", {
    className: `ha__user`
  }, authorImage && /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width:769px)",
    srcSet: authorImage + '&cw=40&ch=40'
  }), /*#__PURE__*/React.createElement("img", {
    style: {
      width: '40px',
      height: '40px'
    },
    src: authorImage + '&cw=40&ch=40',
    alt: authorName
  })), insightAuthorImage && /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width:769px)",
    srcSet: insightAuthorImage + '&cw=40&ch=40'
  }), /*#__PURE__*/React.createElement("img", {
    style: {
      width: '40px',
      height: '40px'
    },
    src: insightAuthorImage + '&cw=40&ch=40',
    alt: insightHeaderAuthorAlt
  })), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, hasAuthorName && /*#__PURE__*/React.createElement(Text, {
    className: "body-medium",
    tag: "p",
    field: currentAuthorName
  }), hasAuthorCategory && /*#__PURE__*/React.createElement(Text, {
    className: "body-small user-category",
    tag: "p",
    field: authorCategory
  }))), /*#__PURE__*/React.createElement("div", {
    className: "ha__desc mobile-description"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-large"
  }, introText)))))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter,
    isSharedCh
  } = _ref2;
  const commonStyleVar = !isSharedCh ? commonStyles : "c1h6ovu9";
  const rtlCommonStyles = isSharedCh ? "r1vrv94s" : rtlStyles;
  const ltrCommonStyles = isSharedCh ? "l1dll4wt" : ltrStyles;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `remove-module-padding ${commonStyleVar} ${fullWidthStyles} ${rtl ? rtlCommonStyles : ltrCommonStyles} ${headerStyle} ${headerImageStyle}`
  }, children);
};
const headerStyle = "hrsvspa";
export const headerImageStyle = "h1kp4efw";
export const commonStyles = "ct7g4ad";
export const ltrStyles = "ljv55x4";
export const rtlStyles = "r1f6w955";
export default HeaderArticle1;